/**代替原来的手机号展示，提供手机号解密获取用户真实手机号
需要展示用的手机号（脱敏数据）phone 需要手机号密文（用于解密）encryptPhone
解密后把真实手机号回传给phone用户展示 提供复制功能 解密后即复制 */
<template>
  <div>
    <div class="decrypt_box" ref="decrypt_box">
      <span
        :class="{ pointer: !needDecrypt && phone }"
        class="decrypt_text"
        ref="copy"
        @click="needDecrypt ? '' : copyFn(phone, $event)"
        >{{ formatterPhoneText(phone) }}</span
      >
      <el-button
        v-if="phone"
        type="text"
        icon="el-icon-copy-document"
        @click="needDecrypt ? decryptBtn($event) : copyFn(phone, $event)"
        title="点我复制解密手机号"
      ></el-button>
    </div>
  </div>
</template>

<script>
import { getUnprotectPhone } from "@/api/common-server.js";
import clipboard from "@/utils/clipboard";
export default {
  name: "DecryptPhone",
  props: {
    phone: {
      // 展示用的***手机号 2026.2.3改版 为密文 业务需要默认也是密文不再是脱敏数据 因此密文就取原脱敏字段phone, 不需要传入密文 encryptPhone，因为部分后端接口没返回对应字段
      type: Number | String,
    },
    encryptPhone: {
      // 手机号密文（优先使用该字段进行解密）
      type: Number | String,
    },
  },
  computed: {
    // 是否需要解密 当前有密文才解密
    needDecrypt() {
      const encryptionInfo = this.phone;
      return encryptionInfo && /[a-zA-Z]+/.test(encryptionInfo);
    },
  },
  mounted() {
    // 解密后显示图标一行导致了换行，此处去掉cell的padding以完整显示 避免大范围改各个列表中手机号单元格的宽度
    const parentClassName = this.$refs.decrypt_box?.parentNode.className || ''
    if (parentClassName.indexOf('cell') >= 0) {
      if (parentClassName.indexOf('decrypt_cell') < 0) {
        this.$refs.decrypt_box.parentNode.className = this.$refs.decrypt_box.parentNode.className + ' decrypt_cell'
      }
      // 部分浏览器 :has 伪类未生效  decrypt_cell 也未生效 添加style
      this.$refs.decrypt_box.parentNode.style.padding = "0"
    }
  },
  methods: {
    formatterPhoneText(phone) {
      phone = phone || ''
      phone = phone.replace(/\,/g, ',\n\r')
      return phone
    },
    // 调用解密
    async decryptBtn() {
      const encryptionInfo = this.encryptPhone || this.phone;
      console.log(encryptionInfo);
      const { code, data, message } = await getUnprotectPhone({
        encryptionInfo,
      });
      if (code == 200) {
        // 更新真实手机号到显示页面
        this.$emit("update:phone", data);
        this.$nextTick(() => {
          // 数据渲染到页面后 模拟点击复制
          this.$refs.copy.click();
        });
        return;
      }
      this.$message.error(message);
    },
    // 解密完后复制 clipboard复制不支持异步 采用模拟点击替代
    copyFn(data, e) {
      clipboard(data, e, "复制成功", "复制失败");
    },
  },
};
</script>

<style>
.cell:has(.decrypt_box), .decrypt_cell {
  padding: 0 !important;
}
</style>

<style scoped>
.decrypt_box {
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: normal;
}
.pointer {
  cursor: pointer;
}
::v-deep .el-button {
  padding: 0;
}
/* 单行超出隐藏样式 */
.decrypt_text {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
